
<template>
    <HeadingContainer :addPaddingBottom="false" heading="Dashboard">
        <div class="row pb3 pb4-m">

            <!-- left cards -->
            <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-6">
                <NameCard class="mt3 mt4-m" :isDashboard = "true" height="100" :user="user"/>
                <RecentMessagesCard class="mt3 mt4-m"/>
                <UpcomingRentalsCard class="mt3 mt4-m"/>
            </div>

            <!-- right cards -->
            <div :class="{'w-100' : xs, 'col-xs-12' : !xs}" class="col-md-6">
                <ListingsCard class="mt3 mt4-m"/>
                <HelpCard class="mt3 mt4-m"/>
            </div>

        </div>
    </HeadingContainer>

</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import NameCard from '@/components/accountSettings/NameCard.vue';
import RecentMessagesCard from '@/components/dashboard/RecentMessagesCard.vue';
import UpcomingRentalsCard from '@/components/dashboard/UpcomingRentalsCard.vue';
import ListingsCard from '@/components/dashboard/ListingsCard.vue';
import HelpCard from '@/components/dashboard/HelpCard.vue';
import { mapState } from 'vuex';

export default {
    components: {
        HeadingContainer,
        NameCard,
        RecentMessagesCard,
        UpcomingRentalsCard,
        ListingsCard,
        HelpCard
    },
    computed: {
        ...mapState('users', ['user']),
        xs() {
            return this.$mq === 'xs';
        }
    }
};
</script>
